import { onIssueChange } from "@mctypes/global.types";
import { IIssueApi, IUserPartial } from "@schemas/issueSchema";
import { IProjectMemberApiItem } from "@schemas/projectSchema";
import { useEffect, useState } from "react";
import { McDropdownMultiUser, McDropdownSingleUser, McTitle } from "..";
import { AccessLevelsEnum, IssueDisabledColumnsEnum } from "../../mc-shared/enums";
import { getUniqValues } from "../../mc-shared/sharedUtils";

const IssueUserSection: React.FC<{
  issue: IIssueApi;
  projectMembers: IProjectMemberApiItem[];
  onChange: onIssueChange;
  accessUsers: IProjectMemberApiItem[];
  accessLevel: AccessLevelsEnum;
  disabledColumns?: string[];
}> = ({ projectMembers, issue, onChange, accessUsers, accessLevel, disabledColumns }) => {
  const [usersListInDropdown, setUsersListInDropdown] = useState<IProjectMemberApiItem[]>([]);

  //TODO: Replace this with a common function between backend and frontend (userHasHasAccesToBoard)
  useEffect(() => {
    if (accessLevel === AccessLevelsEnum.PROJECT || accessLevel == null) {
      setUsersListInDropdown(projectMembers);
    }

    if (accessLevel === AccessLevelsEnum.USERS) {
      const createdBy = issue.createdBy as IProjectMemberApiItem;

      // Include createdBy only if the user exists in projectMembers
      const createdByExistsInProject = projectMembers?.some((m) => m._id === createdBy?._id) ?? false;

      const baseUsers = createdByExistsInProject ? [...accessUsers, createdBy] : accessUsers;

      setUsersListInDropdown(getUniqValues(baseUsers, "_id"));
    }

    if (accessLevel === AccessLevelsEnum.GROUPS) {
      setUsersListInDropdown(accessUsers);
    }
  }, []);

  const issueMemberChange = (user: IProjectMemberApiItem | IUserPartial) => {
    const members = issue.itemMembers == null ? [] : [...issue.itemMembers];
    const prevMembersNames = issue.itemMembers?.map((member) => member.name).join(", ") ?? "";
    const issueMemberIndex = issue.itemMembers.findIndex((i) => i._id === user._id);

    if (issueMemberIndex !== -1) {
      members.splice(issueMemberIndex, 1);
    } else {
      members.push(user);
    }

    onChange(prevMembersNames, members, "itemMembers");
  };

  return (
    <div className="even-columns">
      <div className="d-flex flex-column mr-4">
        {disabledColumns?.includes(IssueDisabledColumnsEnum.OWNER) === false && (
          <McTitle title="Eier">
            <McDropdownSingleUser
              onClear={
                issue.owner?.name != null
                  ? () => onChange(typeof issue.owner !== "string" ? issue.owner?.name : null, null, "owner")
                  : null
              }
              filterActive={projectMembers.length > 10}
              options={usersListInDropdown}
              selected={issue.owner}
              onChange={(user) => onChange(issue.owner?.name, user, "owner")}
            />
          </McTitle>
        )}
      </div>
      <div className="d-flex flex-column mr-4">
        <McTitle title="Ansv. for utførelse">
          <McDropdownSingleUser
            onClear={
              issue.assignedTo?.name != null
                ? () =>
                    onChange(typeof issue.assignedTo !== "string" ? issue.assignedTo?.name : null, null, "assignedTo")
                : null
            }
            filterActive={projectMembers.length > 10}
            options={usersListInDropdown}
            selected={issue.assignedTo}
            onChange={(user) => onChange(issue.assignedTo?.name, user, "assignedTo")}
          />
        </McTitle>
      </div>
      <div className="d-flex flex-column mr-4">
        {disabledColumns?.includes(IssueDisabledColumnsEnum.ITEMMEMBERS) === false && (
          <McTitle title="Medlemmer">
            <McDropdownMultiUser
              filterActive={projectMembers.length > 10}
              allUsers={usersListInDropdown}
              selectedUsers={issue.itemMembers}
              onChange={(user) => issueMemberChange(user)}
            />
          </McTitle>
        )}
      </div>
    </div>
  );
};

export default IssueUserSection;
